import React from 'react';
import PartnershipOverview from './PartnershipOverview';
import TopPartnerships from './TopPartnerships';
import PartnershipPerformanceChart from './PartnershipPerformanceChart';

/**
 * Partnerships tab content for Player Dashboard
 */
const PlayerPartnershipsTab = ({ 
  partnershipOverview,
  topPartnerships,
  partnershipPerformanceData,
  isLoadingPartnerships,
  currentPlayerId,
  selectedPartnership
}) => {
  return (
    <div className="space-y-8">
      {/* Partnership Overview */}
      <PartnershipOverview 
        partnershipData={partnershipOverview} 
        isLoading={isLoadingPartnerships} 
      />
      
      {/* Top Partnerships */}
      <TopPartnerships 
        partnerships={topPartnerships}
        isLoading={isLoadingPartnerships}
        currentPlayerId={currentPlayerId}
      />
      
      {/* Partnership Performance Chart */}
      <PartnershipPerformanceChart 
        performanceData={partnershipPerformanceData}
        isLoading={isLoadingPartnerships}
        selectedPartnership={selectedPartnership}
      />
    </div>
  );
};

export default PlayerPartnershipsTab;
